// Brand configuration — the single place components read names and the logo from.
// Replace /assets/images/logo.svg (and these strings if needed) when official brand assets arrive.
export const brand = Object.freeze({
  companyName: 'NextGen Wizards',
  productName: 'NGW EMS',
  productLongName: 'Employee Management System',
  logoSrc: '/assets/images/logo.svg',
  logoAlt: 'NextGen Wizards logo',
  tagline: 'People, projects and operations — in one secure place.',
  loginHeadline: 'Run NextGen Wizards from one workspace.',
  loginCopy: 'Attendance, projects, approvals and people operations, with access that follows each person’s role.',
});
